import { inject, Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { PaymentService } from '@services/payment/payment.service';
import { PaymentV2Service } from '@services/payment-v2/payment-v2.service';
import { UtilService } from '@services/util/util.service';
import { VariablesService } from '@services/variables/variables.service';
import { VwoService } from '@services/vwo/vwo.service';
import { AuthService } from '@services/auth/auth.service';
import { ComponentLoader } from '@core-components/component-loader/component-loader.component';

@Component({
  selector: 'app-quickdonate-card',
  standalone: true,
  imports: [
    NgIf,
    ComponentLoader
  ],
  templateUrl: './quickdonate-card.component.html',
  styleUrls: ['./quickdonate-card.component.scss']
})
export class QuickdonateCardComponent {

  private readonly auth = inject(AuthService);

  public vars = inject(VariablesService);
  public vwo = inject(VwoService);
  public util = inject(UtilService);
  public paymentService = inject(PaymentService);
  public paymentV2 = inject(PaymentV2Service);
  recentPaymodes = [];
  orders = [];
  @Input() currency;
  isMobile = this.vars.isMobile;
  user;

  ngOnInit() {
    this.vars.userData.subscribe(res => {
      this.user = res;
    })
    if (this.user?.lastorder) {
      this.getPaymentOptionsforQD(this.currency);
    }
  }

  getPaymentOptionsforQD(currency) {
    let params = `&mobile_no=${this.user?.phone_1}&is_mobile=${this.vars.isMobile ? 1 : 0}&amount=${this.user?.lastorder?.donated_amount_local}`;
    if (this.vars.utmsUrlString) params += `&${this.vars.utmsUrlString}`;
    this.paymentService.getPaymentOptions(currency, params).subscribe((res: any) => {
      if (this.vwo.new_upi_AB() && res?.data?.options) res.data.options['vpa_collect_enabled'] = false;
      if (res?.data?.options?.PREVIOUSPAYMENTGATEWAY) {
        this.recentPaymodes[0] = Object.values(res?.data?.options?.PREVIOUSPAYMENTGATEWAY)[0];
        this.recentPaymodes[1] = Object.values(res?.data?.options?.PREVIOUSPAYMENTGATEWAY)[1] || Object.values(res.data.options.PREVIOUSPAYMENTGATEWAY)[0];
      } else {
        this.recentPaymodes[0] = null;
        this.recentPaymodes[1] = null;
      }
    });
    this.getBeneficiaries();
  }

  async getBeneficiaries() {
    const qparam = `?with=campaign;campaign.beneficiary;campaign.beneficiaryname;campaign.mediaBeneficiary;campaign.campaigner.avtar;campaign.updatesCount;campaign.basicinfo;campaign.hospital;`
      .concat(`campaign.viewmedicalbill;campaign.leaderboard;campaign.theater;campaign.storyTitle;campaign.storyDescription&limit=200&orderBy=creation_date&sortedBy=desc`);
    const resData = await this.auth.getUserOrders(qparam);
    if (resData?.data?.length) {
      this.orders[0] = resData.data[0];
      this.orders[1] = resData.data[1] || '';
      this.orders = this.orders.filter(elm => elm);
    }
  }

}
